// css =>
import "../../BaseStructure.css";
import Styled from "./selectBox.module.css";

// react =>
import { forwardRef } from "react";

// type =>
import { SELECT_OPTION, SELECT_BOX_PROPS_TYPE } from "./selectBoxType";

const SelectBox = forwardRef<HTMLSelectElement, SELECT_BOX_PROPS_TYPE>(
    ({ title, options, value, onChange }, ref) => {
        return(
            <>
                <div className={`col-1 ${ Styled.TittleSection } `}>
                    <h3>{ title }</h3>
                </div>

                <div className={`col-4 ${ Styled.SelectBoxSectionFrame } `}>
                    <div className="col-12" id={ Styled.SelectBoxSection }>
                        <select
                            ref={ ref }
                            value={ value }
                            onChange={(e) => onChange?.(e.target.value)}
                        >
                            {
                                options.map(( option: SELECT_OPTION ) => {
                                    return <option value={ option.value }>{ option.title }</option>
                                })
                            }
                        </select>
                    </div>
                </div>
            </>
        );
    }
);

export default SelectBox;
